export class LetterSubscriber {
    
    public id: string = "0";
    public name: string;
    public subject: string;
    public type: string;
    public text: string;
    public text_back: string;
    public context_id: string

    public image_url: string;
    public deleted: boolean;

    constructor() {}
}

export class LetterSubscriberSent {
    
  public id: string = "0";
  public letter_id: string;

  public member_id: string;
  public member_name: string;
  public member_email: string;

  public sentDate: Date;
  public refuse: boolean;

  constructor() {}
}
